import React, { useState } from "react";
import { Container, Row, Col, Carousel, Button } from "react-bootstrap";

export default function AdsSection() {
    const [index, setIndex] = useState(0);

    const bigSlides = [
        { img: "/assets/1.png", btn: "Call Now" },
        { img: "/assets/2.png", btn: "Book Now" },
        { img: "/assets/3.png", btn: "Call Now" },
    ];

    const rightCards = [
        { img: "/assets/R1.png", btn: "Call Now" },
        { img: "/assets/R2.png", btn: "Book Now" },
        { img: "/assets/R3.png", btn: "Call Now" },
        { img: "/assets/R4.png", btn: "Book Now" },
    ];

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    return (
        <>
            {/* 🔥 FORCE WHITE TEXT STYLE */}
            <style>{`
        .ads-slider-btn {
          background-color: #0076d7 !important;
          color: #ffffff !important;
          border: none !important;
        }
        .ads-slider-btn:hover {
          background-color: #005bb5 !important;
          color: #ffffff !important;
        }
      `}</style>

            <section className="my-3 mt-1">
                <Container>
                    <Row className="g-4">

                        {/* LEFT SIDE BIG SLIDER */}
                        <Col md={7}>
                            <Carousel
                                activeIndex={index}
                                onSelect={handleSelect}
                                interval={1500}
                                fade
                                controls
                                indicators
                            >
                                {bigSlides.map((slide, idx) => (
                                    <Carousel.Item key={idx}>
                                        <div
                                            className="rounded shadow-sm position-relative"
                                            style={{
                                                width: "740px",
                                                height: "339px",
                                                borderRadius: "12px",
                                                overflow: "hidden",
                                            }}
                                        >
                                            <img
                                                src={slide.img}
                                                alt="slide"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                }}
                                            />

                                            {/* ✅ FIXED BUTTON */}
                                            <Button
                                                className="ads-slider-btn px-4 py-2 fw-semibold"
                                                style={{
                                                    position: "absolute",
                                                    left: "15px",
                                                    bottom: "15px",
                                                    borderRadius: "4px",
                                                }}
                                            >
                                                {slide.btn}
                                            </Button>
                                        </div>
                                    </Carousel.Item>
                                ))}
                            </Carousel>
                        </Col>

                        {/* RIGHT SIDE CARDS */}
                        <Col md={5}>
                            <Row className="g-4">
                                {rightCards.map((item, idx) => (
                                    <Col xs={12} sm={6} key={idx}>
                                        <div
                                            className="position-relative shadow-sm w-100"
                                            style={{
                                                borderRadius: "6px",
                                                overflow: "hidden",
                                                aspectRatio: "16/10",
                                            }}
                                        >
                                            <img
                                                src={item.img}
                                                alt="promo"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                }}
                                            />

                                            {/* ✅ FIXED SMALL BUTTON */}
                                            <Button
                                                size="sm"
                                                className="ads-slider-btn fw-semibold"
                                                style={{
                                                    position: "absolute",
                                                    left: "10px",
                                                    bottom: "10px",
                                                    borderRadius: "4px",
                                                    padding: "4px 12px",
                                                    fontSize: "0.8rem",
                                                }}
                                            >
                                                {item.btn}
                                            </Button>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Col>

                    </Row>
                </Container>
            </section>
        </>
    );
}
